import * as React from 'react';
import {Link} from 'react-router-dom';
import {useEffect, useState} from "react";
import {addClient} from "../../../api";
import {useHistory} from "react-router";


const AddClient: React.FunctionComponent = () => {
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [email, setEmail] = useState("");
    const [ssn, setSsn] = useState("");
    const [dlState, setDlState] = useState("");
    const [dlNumber, setDlNumber] = useState("");
    const [dateOfBirth, setDateOfBirth] = useState("");
    const [telephone, setTelephone] = useState("");
    const [addressLine1, setAddressLine1] = useState("");
    const [addressLine2, setAddressLine2] = useState("");
    const [city, setCity] = useState("");
    const [stateCode, setStateCode] = useState("");
    const [zip, setZip] = useState("");
    const [assessmentDate, setAssessmentDate] = useState("");
    const [assessmentTime, setAssessmentTime] = useState("");
    const [doRedirectToSearch, setDoRedirectToSearch] = useState(false);
    const history = useHistory();


    useEffect(() => {
        if (doRedirectToSearch) {
            history.push({
                pathname: "/m/clients"
            });
        }
    }, [doRedirectToSearch, history]);

    const doAdd = () => {
        addClient({
            address: {
                addressLine1: addressLine1,
                addressLine2: addressLine2,
                city: city,
                state: stateCode,
                zip: zip
            },
            firstName: firstName,
            lastName: lastName,
            socialsecurityNumber: ssn,
            driverslicenseNumber: dlNumber,
            driverslicenseState: dlState,
            dateofBirth: dateOfBirth,
            telephoneNumber: telephone,
            email: email,
            dateTimeofAssessment: assessmentDate + "T" + assessmentTime,
            clientDiagnosis: "",
            drugTestDueDate: ""
        }).then((c) => {
            setDoRedirectToSearch(true);
        }).then((e) => console.log(e));
    }

    return (<>
        <div className={"row"}>
            <div className={"col-lg-12 mb-3 "}>
                <h2>Add Client</h2>
            </div>
            <form onSubmit={(e) => {
                e.preventDefault();
                doAdd();
            }}>
                <div className={"col-lg-12 mb-3 "}>

                    <div className="form-row align-items-center">
                        <div className="col-sm-3 my-1">
                            <label htmlFor="inputEmail4">First Name</label>
                            <input required={true} type="text" className="form-control" id="inlineFormInputName"
                                   value={firstName} onChange={(e) => setFirstName(e.target.value)}
                            />
                        </div>
                        <div className="col-sm-3 my-1">
                            <label htmlFor="inputEmail4">Last Name</label>
                            <input required={true} type="text" className="form-control" id="inlineFormInputName"
                                   value={lastName} onChange={(e) => setLastName(e.target.value)}
                            />
                        </div>
                        <div className="col-sm-3 my-1">
                            <label htmlFor="inputEmail4">Email</label>
                            <input required={true} type="email" className="form-control" id="inlineFormInputName"
                                   value={email} onChange={(e) => setEmail(e.target.value)}
                            />
                        </div>
                        <div className="col-sm-3 my-1">
                            <label htmlFor="inputEmail4">SSN</label>
                            <input required={true} type="text" className="form-control" id="inlineFormInputName"
                                   value={ssn} onChange={(e) => setSsn(e.target.value)}
                            />
                        </div>
                        <div className="col-sm-3 my-1">
                            <label htmlFor="inputEmail4">Driver's License State</label>
                            <select required={true} id="inputState" className="form-control"
                                    value={dlState} onChange={(e) => setDlState(e.target.value)}
                            >
                                <option value={""}>Choose...</option>
                                <option value={"NC"}>NC</option>
                                <option value="AL">AL</option>
                                <option value="AK">AK</option>
                                <option value="AZ">AZ</option>
                                <option value="AR">AR</option>
                                <option value="CA">CA</option>
                                <option value="CO">CO</option>
                                <option value="CT">CT</option>
                                <option value="DE">DE</option>
                                <option value="DC">DC</option>
                                <option value="FL">FL</option>
                                <option value="GA">GA</option>
                                <option value="HI">HI</option>
                                <option value="ID">ID</option>
                                <option value="IL">IL</option>
                                <option value="IN">IN</option>
                                <option value="IA">IA</option>
                                <option value="KS">KS</option>
                                <option value="KY">KY</option>
                                <option value="LA">LA</option>
                                <option value="ME">ME</option>
                                <option value="MD">MD</option>
                                <option value="MA">MA</option>
                                <option value="MI">MI</option>
                                <option value="MN">MN</option>
                                <option value="MS">MS</option>
                                <option value="MO">MO</option>
                                <option value="MT">MT</option>
                                <option value="NE">NE</option>
                                <option value="NV">NV</option>
                                <option value="NH">NH</option>
                                <option value="NJ">NJ</option>
                                <option value="NM">NM</option>
                                <option value="NY">NY</option>
                                <option value="ND">ND</option>
                                <option value="OH">OH</option>
                                <option value="OK">OK</option>
                                <option value="OR">OR</option>
                                <option value="PA">PA</option>
                                <option value="RI">RI</option>
                                <option value="SC">SC</option>
                                <option value="SD">SD</option>
                                <option value="TN">TN</option>
                                <option value="TX">TX</option>
                                <option value="UT">UT</option>
                                <option value="VT">VT</option>
                                <option value="VA">VA</option>
                                <option value="WA">WA</option>
                            </select>
                        </div>
                        <div className="col-sm-3 my-1">
                            <label htmlFor="inputEmail4">Driver's License Number</label>
                            <input required={true} type="text" className="form-control" id="inlineFormInputName"
                                   value={dlNumber} onChange={(e) => setDlNumber(e.target.value)}
                            />
                        </div>
                        <div className="col-sm-3 my-1">
                            <label htmlFor="inputEmail4">Date of Birth</label>
                            <input required={true} type="date" className="form-control" id="inlineFormInputName"
                                   value={dateOfBirth} onChange={(e) => setDateOfBirth(e.target.value)}
                            />
                        </div>
                        <div className="col-sm-3 my-1">
                            <label htmlFor="inputEmail4">Telephone Number</label>
                            <input required={true} type="tel" className="form-control" id="inlineFormInputName"
                                   value={telephone} onChange={(e) => setTelephone(e.target.value)}
                            />
                        </div>
                    </div>
                </div>
                <div className={"col-lg-12 mb-3 "}>
                    <h6>Client Address</h6>
                </div>
                <div className={"col-lg-12 mb-3 "}>
                    <div className="form-row align-items-center">
                        <div className="col-sm-3 my-1">
                            <label htmlFor="inputEmail4">Address Line 1</label>
                            <input required={true} type="text" className="form-control" id="inlineFormInputName"
                                   value={addressLine1} onChange={(e) => setAddressLine1(e.target.value)}
                            />
                        </div>
                        <div className="col-sm-3 my-1">
                            <label htmlFor="inputEmail4">Address Line 2</label>
                            <input type="text" className="form-control" id="inlineFormInputName"
                                   value={addressLine2} onChange={(e) => setAddressLine2(e.target.value)}
                            />
                        </div>
                        <div className="col-sm-3 my-1">
                            <label htmlFor="inputEmail4">City</label>
                            <input required={true} type="text" className="form-control" id="inlineFormInputName"
                                   value={city} onChange={(e) => setCity(e.target.value)}
                            />
                        </div>
                        <div className="col-sm-3 my-1">
                            <label htmlFor="inputEmail4">State</label>
                            <select required={true} id="inputState" className="form-control"
                                    value={stateCode} onChange={(e) => setStateCode(e.target.value)}>
                                <option value={""}>Choose...</option>
                                <option value={"NC"}>NC</option>
                                <option value="AL">AL</option>
                                <option value="AK">AK</option>
                                <option value="AZ">AZ</option>
                                <option value="AR">AR</option>
                                <option value="CA">CA</option>
                                <option value="CO">CO</option>
                                <option value="CT">CT</option>
                                <option value="DE">DE</option>
                                <option value="DC">DC</option>
                                <option value="FL">FL</option>
                                <option value="GA">GA</option>
                                <option value="HI">HI</option>
                                <option value="ID">ID</option>
                                <option value="IL">IL</option>
                                <option value="IN">IN</option>
                                <option value="IA">IA</option>
                                <option value="KS">KS</option>
                                <option value="KY">KY</option>
                                <option value="LA">LA</option>
                                <option value="ME">ME</option>
                                <option value="MD">MD</option>
                                <option value="MA">MA</option>
                                <option value="MI">MI</option>
                                <option value="MN">MN</option>
                                <option value="MS">MS</option>
                                <option value="MO">MO</option>
                                <option value="MT">MT</option>
                                <option value="NE">NE</option>
                                <option value="NV">NV</option>
                                <option value="NH">NH</option>
                                <option value="NJ">NJ</option>
                                <option value="NM">NM</option>
                                <option value="NY">NY</option>
                                <option value="ND">ND</option>
                                <option value="OH">OH</option>
                                <option value="OK">OK</option>
                                <option value="OR">OR</option>
                                <option value="PA">PA</option>
                                <option value="RI">RI</option>
                                <option value="SC">SC</option>
                                <option value="SD">SD</option>
                                <option value="TN">TN</option>
                                <option value="TX">TX</option>
                                <option value="UT">UT</option>
                                <option value="VT">VT</option>
                                <option value="VA">VA</option>
                                <option value="WA">WA</option>
                            </select>
                        </div>
                        <div className="col-sm-3 my-1">
                            <label htmlFor="inputEmail4">Zip</label>
                            <input required={true} type="text" className="form-control" id="inlineFormInputName"
                                   value={zip} onChange={(e) => setZip(e.target.value)}
                            />
                        </div>
                    </div>

                </div>
                <div className={"col-lg-12 mb-3 "}>
                    <h6>Assessment</h6>
                </div>
                <div className={"col-lg-12 mb-3 "}>
                    <div className="form-row align-items-center">
                        <div className="col-sm-3 my-1">
                            <label htmlFor="inputEmail4">Date</label>
                            <input required={true} type="date" className="form-control" id="inlineFormInputName"
                                   value={assessmentDate} onChange={(e) => setAssessmentDate(e.target.value)}
                            />
                        </div>
                        <div className="col-sm-3 my-1">
                            <label htmlFor="inputEmail4">Time</label>
                            <input required={true} type="time" className="form-control" id="inlineFormInputName"
                                   value={assessmentTime} onChange={(e) => setAssessmentTime(e.target.value)}
                            />
                        </div>
                    </div>
                </div>
                <div className={"col-lg-12 mb-3 "}>
                    <Link to={"/m/clients"}>
                        <button type={"button"} className={"btn btn-danger mr-3"}>
                            Cancel
                        </button>
                    </Link>
                    <button type={"submit"} className={"btn btn-primary"}
                            >
                        Add Client
                    </button>
                </div>
            </form>
        </div>
    </>);
};

export default AddClient;